import { render, staticRenderFns } from "./PersonnelComponent.vue?vue&type=template&id=1ea02f01&"
import script from "./PersonnelComponent.vue?vue&type=script&lang=ts&"
export * from "./PersonnelComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea02f01')) {
      api.createRecord('1ea02f01', component.options)
    } else {
      api.reload('1ea02f01', component.options)
    }
    module.hot.accept("./PersonnelComponent.vue?vue&type=template&id=1ea02f01&", function () {
      api.rerender('1ea02f01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/OutProcessing/PersonnelComponent.vue"
export default component.exports